import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Uygulama } from './Uygulama.js'
import './stil.css'

const kok = document.getElementById('kok')
if (!kok) throw new Error('#kok bulunamadı')
createRoot(kok).render(
  <StrictMode>
    <Uygulama />
  </StrictMode>,
)
